import { motion } from "framer-motion";
import React from "react";
import { commonOpacity } from "../animateConstant";
import { getFixedStyle } from "../hook/useDeviceType";

const DetailWrapper = ({ children, wrapperClassName, closeAnimate }) => {
  const motionProps = closeAnimate
    ? {}
    : {
        initial: commonOpacity.initial,
        animate: commonOpacity.animate,
        exit: commonOpacity.exit,
        transition: commonOpacity.transition,
      };

  return (
    <motion.main
      {...motionProps}
      className={` ${getFixedStyle()} overflow-x-hidden bg-base-white dark:bg-base-deep-black ${wrapperClassName}`}
    >
      {children}
    </motion.main>
  );
};

export default DetailWrapper;
